import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=573358ab&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=573358ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573358ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573358ab')) {
      api.createRecord('573358ab', component.options)
    } else {
      api.reload('573358ab', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=573358ab&scoped=true&", function () {
      api.rerender('573358ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ra4qKPI393ug/JS/comp/CookieBox.vue"
export default component.exports